$(document).ready(
    function () {

        let p = $("body").attr("p");

        if (p == 'organizer_event_customers' || p == 'organizer_event_subevent_customers' || p == 'organizer_event_period_tickets') {

            $(document).on("click", ".ticket-send", function (e) {

                e.preventDefault();
                let ticketId = $(this).attr('data-ticket-send');
                let orderId = $(this).closest('.modal').data('order-id');

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_event_customers/send_ticket",
                    data: {
                        ticket_id: ticketId,
                        order_id: orderId
                    }
                })
                    .done(function (data) {

                        if (data.message !== undefined && data.message !== null) {
                            $('#modal-footer-'  + orderId + '-' + ticketId + '.alert').remove();
                            prependAlert('#modal-footer-'  + orderId + '-' + ticketId, data.message, 'success', null, '#modal-ticket-' + orderId + '-' + ticketId);
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                    })

            });

        }

    }
);

